/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const country = async (): Promise<any> => {
  const country = useJSONStore.getState().country;
  const token = useUserStore.getState().userToken;
  const setCountry = useJSONStore.getState().setCountry;

  if (country.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.country}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setCountry(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default country;
